jQuery(function($)
{
    var api = orion.api.notifications,
        hideFeedbackUntil = 43200, // seconds after the 'unread notifications' feedback message annoys again after the last removal
        $body = $('body'),
        $unreadNotificationBadge = $('.js-notification-count'),
        $unreadNotificationNote = $('.js-notification-note'),
        showFeedback = true;

    /**
	 * Get notification count and trigger feedback
	 */
    function initNotifications()
    {
        var readPromise = api.read();

        readPromise.done(function(data)
        {
            var { totalUnreadNotificationsCount } = data;

            handleNotificationCountFeedback(totalUnreadNotificationsCount);
        });
    }

    /**
	 * Mark notification message as read
	 */
    function handleHasBeenReadClick()
    {
        console.log('notifications.js handleHasBeenReadClick()');
        var notificationId = $(this).data('notification-id');

        var markAsReadPromise = api.markAsRead(notificationId);
        var [thisHtml] = $(this);

        markAsReadPromise.done(function()
        {
            changeMarkupAsRead(thisHtml);
            initNotifications();
        });
    }

    /**
	 * Mark all unimportant notification messages as read
	 */
    function handleAllUnimportantHasBeenReadClick()
    {
        console.log('notifications.js handleAllUnimportantHasBeenReadClick()');

        var markAsReadPromise = api.markAllUnimportantAsRead();

        markAsReadPromise.done(function()
        {
            $('.js-standard-notification').each(function()
            {
                var [thisHtml] = $(this);
                changeMarkupAsRead(thisHtml);
            });
            initNotifications();
        });
    }

    /**
	 * Change notification markup to has been read without page reload
	 */
    function changeMarkupAsRead(notification)
    {
        $(notification).find('.js-notification-unread-icon').remove();
        $(notification).find('.js-notification-title').css({ 'font-weight': 'normal' });
        $(notification).removeClass('js-folddown-trigger');
    }

    /**
	 * Checks if the unread notification feedback has to be shown
	 *
	 * @return {bool}
	 */
    function checkShowFeedback()
    {
        // check, if the local storage item with the timestamp after the last unread notification feedback removal
        if (localStorage.getItem('notification-feedback-removed-time') !== null)
        {
            // calc the diff between the last removal und now in seconds
            var secondsSinceLastRemoval = (new Date().getTime()
				- localStorage.getItem('notification-feedback-removed-time')) / 1000;

            if (secondsSinceLastRemoval < hideFeedbackUntil)
            {
                showFeedback = false;
            }

            console.log('Unread notification feedback will appear again after '
				+ (hideFeedbackUntil - secondsSinceLastRemoval) + ' seconds');
        }

        return showFeedback;
    }

    /**
	 * Show unread notification feedback message
	 */
    function showUnreadNotificationFeedback()
    {
        var feedbackMsg = $('#feedback-important-unread-notification').html();

        var $feedbackMsgElement = $('<div class="feedback info js-feedback">'
			+ '<i class="fa-regular fa-info-circle"></i><p>' + feedbackMsg + '</p>'
			+ '<a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');

        $feedbackMsgElement.on('click', function()
        {
            var timestampNow = new Date().getTime();

            localStorage.setItem('notification-feedback-removed-time', timestampNow);
        });

        $body.append($feedbackMsgElement);
        $body.trigger('feedback-added');

        showFeedback = false;
    }

    /**
	 * Shows the amount of unread notifications in the site header and a feedback message
	 */
    function handleNotificationCountFeedback(totalUnreadNotificationsCount)
    {
        if (totalUnreadNotificationsCount == 0)
        {
            orion.hide($unreadNotificationBadge);
            orion.hide($unreadNotificationNote);
        }
        else
        {
            if (showFeedback && checkShowFeedback())
            {
                showUnreadNotificationFeedback();
            }
            orion.show($unreadNotificationBadge);
            orion.show($unreadNotificationNote);
        }
        $unreadNotificationBadge.html(totalUnreadNotificationsCount);
    }

    if ($body.hasClass('authorized'))
    {
        initNotifications();
        $body
            .on('click', '.js-folddown-trigger', handleHasBeenReadClick)
            .on('click', '.js-notification-set-all-unimportant-has-been-read', handleAllUnimportantHasBeenReadClick);
    }
});
